import React from "react";
import { Input, type InputProps, type InputRef } from "antd";

// One-time-code autofill and the numeric keypad on phones.
const OtpInput = React.forwardRef<InputRef, InputProps>((props, ref) => (
	<Input ref={ref} inputMode="numeric" autoComplete="one-time-code" maxLength={7} placeholder="123456" {...props} />
));

OtpInput.displayName = "OtpInput";

export default OtpInput;
